import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'AllPersonnel',
  //   description: 'description of AllPersonnel',
  //   url: '/all-personnel',
  // },
];

export default help;
